export enum ExciseDrinkCategory {
    Beer = "Beer",
    Wine = "Wine",
    Intermediate = "Intermediate",
    Other = "Other"
}
